import { formValidators } from '../../../utils/form/validators';

export type FormFieldValidationMessages = {
  firstName: {
    required: string;
    invalid: string;
  };
  lastName: {
    required: string;
    invalid: string;
  };
  email: {
    required: string;
    invalid: string;
  };
  phoneNumber: {
    required: string;
    invalid: string;
  };
  address: string;
  city: {
    required: string;
    invalid: string;
  };
  zipCode: {
    required: string;
    invalid: string;
  };
  state: string;
  installAddressPoBox: string;
};

export const createFormFieldValidators = (messages: FormFieldValidationMessages) => ({
  firstName: [
    formValidators.required(messages.firstName.required),
    formValidators.alpha(messages.firstName.invalid),
  ],
  lastName: [
    formValidators.required(messages.lastName.required),
    formValidators.alpha(messages.lastName.invalid),
  ],
  email: [
    formValidators.required(messages.email.required),
    formValidators.email(messages.email.invalid),
  ],
  phoneNumber: [
    formValidators.required(messages.phoneNumber.required),
    formValidators.usPhoneNumber(messages.phoneNumber.invalid),
  ],
  addressLine1: [formValidators.required(messages.address)],
  city: [
    formValidators.required(messages.city.required),
    formValidators.alpha(messages.city.invalid),
  ],
  postalCode: [
    formValidators.required(messages.zipCode.required),
    formValidators.usZipCode(messages.zipCode.invalid),
  ],
  regionOrStateCode: [formValidators.required(messages.state)],
  merchandiseLocationLine1: [
    formValidators.required(messages.address),
    formValidators.hasPoBox(messages.installAddressPoBox),
  ],
  merchandiseLocationCity: [
    formValidators.required(messages.city.required),
    formValidators.noDigits(messages.city.invalid),
  ],
  merchandiseLocationPostalCode: [
    formValidators.required(messages.zipCode.required),
    formValidators.usZipCode(messages.zipCode.invalid),
  ],
  merchandiseLocationRegionOrStateCode: [formValidators.required(messages.zipCode.required)],
});
